module.exports = __webpack_public_path__ + "img/news2.530f9b7b.png";